import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";

const EASE = [0.16, 1, 0.3, 1];

const TESTIMONIALS = [
  {
    quote:
      "I failed my dosage calculation exam twice before I found Dr. Louden. His step-by-step method finally made it click — I passed my next exam with a 96.",
    name: "Maria S.",
    role: "Nursing Student — Nursing Algebra",
  },
  {
    quote:
      "The Leadership course changed the way I run my team. Practical, direct, and grounded in real experience — not textbook theory.",
    name: "James T.",
    role: "Operations Manager — Leadership Course",
  },
  {
    quote:
      "Dr. Louden is patient and explains algebra in plain language. After four tutoring sessions, my confidence with math completely turned around.",
    name: "Denise W.",
    role: "Adult Learner — Math Tutoring",
  },
  {
    quote:
      "His books speak to real life. I bought three and gifted two — powerful, honest writing that stays with you long after the last page.",
    name: "Andre B.",
    role: "Reader — The Library Collection",
  },
  {
    quote:
      "The canvas I purchased is now the centerpiece of my office. Distinctive work with real soul — visitors ask about it every single week.",
    name: "Patricia L.",
    role: "Art Collector",
  },
];

export const Testimonials = () => {
  return (
    <section
      data-testid="testimonials-section"
      className="border-t border-white/10 bg-[#0D0D12] px-6 md:px-12 py-24 md:py-28"
    >
      <div className="mx-auto max-w-[1200px]">
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="text-xs uppercase tracking-[0.4em] text-[#7C3AED]"
        >
          What Clients Say
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, ease: EASE }}
          className="mt-4 font-display text-4xl uppercase tracking-tight text-white sm:text-5xl"
        >
          Voices of Success
        </motion.h2>
        <div className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={t.name}
              data-testid={`testimonial-card-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: (i % 3) * 0.12, ease: EASE }}
              className="relative flex flex-col overflow-hidden rounded-xl border border-white/10 bg-[#050505] p-8 transition-colors duration-300 hover:border-[#7C3AED]/50"
            >
              <Quote className="h-6 w-6 text-[#7C3AED]" />
              <div
                data-testid={`testimonial-stars-${i}`}
                className="mt-4 flex gap-1"
                aria-label="5 out of 5 stars"
              >
                {Array.from({ length: 5 }).map((_, s) => (
                  <Star key={s} className="h-4 w-4 fill-[#7C3AED] text-[#7C3AED]" />
                ))}
              </div>
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-white/75 md:text-base">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-6 border-t border-white/10 pt-4">
                <div className="text-sm font-semibold text-white">{t.name}</div>
                <div className="mt-0.5 text-[11px] uppercase tracking-[0.2em] text-white/45">
                  {t.role}
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
